// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"6040c416","256":"2074a696","276":"2952cce7","646":"951f9c1b","961":"dc5394ad"}[chunkId] + ".chunk.js";
};